import * as angular from "angular";
import {ServiceType} from "../types/service.type";
import {ServicesAssignResourceColumnsModel} from "../models/services-assign-resource-columns.model";
import {servicesTableColumns} from "./services-table-columns.const";

const serviceTypes = [
  ServiceType.Delivery,
  ServiceType.Operation
];

const serviceProgressSteps = {
  Delivery: [
    {stepName: 'Created', stepNumber: 1},
    {stepName: 'Routed', stepNumber: 2},
    {stepName: 'Assigned', stepNumber: 3},
    {stepName: 'Heading pickup', stepNumber: 4},
    {stepName: 'Arrived pickup', stepNumber: 5},
    {stepName: 'Departed pickup', stepNumber: 6},
    {stepName: 'Heading dropoff', stepNumber: 7},
    {stepName: 'Arrived dropoff', stepNumber: 8},
    {stepName: 'Departed dropoff', stepNumber: 9}
  ],
  Operation: [
    {stepName: 'Created', stepNumber: 1},
    {stepName: 'Routed', stepNumber: 2},
    {stepName: 'Assigned', stepNumber: 3},
    {stepName: 'Heading location', stepNumber: 4},
    {stepName: 'Arrived location', stepNumber: 5},
    {stepName: 'Departed location', stepNumber: 6}
  ]
};

const servicesAssignRouteTableColumns = {
  routeStatus: {enabled: true, order: 1, permission: undefined},
  vehicle: {enabled: true, order: 2, permission: undefined},
  agent: {enabled: true, order: 3, permission: undefined},
  stops: {enabled: true, order: 4, permission: undefined},
  totals: {enabled: true, order: 5, permission: undefined},
  capacityRisk: {enabled: true, order: 6, permission: undefined},
  timeWindow: {enabled: true, order: 7, permission: undefined},
  accounts: {enabled: true, order: 8, permission: undefined},
  branches: {enabled: true, order: 9, permission: undefined},
  serviceArea: {enabled: true, order: 10, permission: undefined}
}

const servicesAssignAgentTableColumns = {
  phoneNumber: {enabled: false, order: 1, permission: undefined},
  skills: {enabled: false, order: 2, permission: undefined},
  tags: {enabled: true, order: 3, permission: undefined},
  branches: {enabled: false, order: 4, permission: undefined},
  tasks: {enabled: true, order: 5, permission: undefined},
  availability: {enabled: false, order: 6, permission: undefined},
  carrier: {enabled: false, order: 7, permission: undefined},
  price: {enabled: false, order: 8, permission: undefined},
  capacity: {enabled: true, order: 9, permission: undefined},
  logisticVehicles: {enabled: true, order: 9, permission: undefined}
}

const servicesAssignResourceAllocationTableColumns: ServicesAssignResourceColumnsModel = {
  primary: {
    logistics: {enabled: true, order: 1, permission: undefined},
    agent: {enabled: true, order: 2, permission: undefined},
    route: {enabled: true, order: 3, permission: undefined},
    stops: {enabled: true, order: 4, permission: undefined},
    timeWindow: {enabled: true, order: 5, permission: undefined},
    serviceArea: {enabled: true, order: 6, permission: undefined},
    totals: {enabled: true, order: 7, permission: undefined},
    capacityRisk: {enabled: true, order: 8, permission: undefined},
    score: {enabled: true, order: 9, permission: undefined},
  },
  load: {
    weight: {enabled: true},
    volume: {enabled: true},
    packages: {enabled: true},
    spots: {enabled: true},
    pallets: {enabled: true}
  },
  capacity: {
    weight: {enabled: true},
    volume: {enabled: true},
    packages: {enabled: true},
    spots: {enabled: true}
  }
}


const servicesTableColumnsMap = {
  location: true,
  eta: true,
  timeWindow: true,
  urgency: false,
  agent: true,
  serviceAreas: true,
  risks: false,
  invoice: false,
  displayId: false,
  orderId: false,
  account: false,
  progress: false,
  contact: false,
  distance: false,
  load: false,
  price: false,
  created: false,
  programType: false,
  timeToDeliver: false,
  cancellationReason: false,
  proNumber: false,
  taskApprovalStatus: false,
  itemsIds: false,
  itemsTypes: false,
  itemsBarcodes: false,
  notes: false,
  resource: false,
  referenceIds: false,
  operationalUnits: false
}

const threePlServicesTableColumns = {
  orderId: true,
  account: true,
  supplierAccount: true,
  location: true,
  contact: true,
  eta: true,
  distance: true,
  timeWindow: true,
  price: true,
  serviceAreas: false,
  taskApprovalStatus: false,
  created: true,
  programType: true,
  timeToDeliver: true,
  notes: true,
  operationalUnits: true
}


const sendSmsOptions = [
  'Pickup',
  'Dropoff',
  'Account',
  'Agent'
];

const riskTypes = [
  'ServiceIsLate',
  'AddressNotAccurate',
  'ContactNotAvailable',
];

const statusTitle = {
  InAuction: 'In Auction',
  InMarket: 'In Market',
  Assigned: 'Assigned',
  Unassigned: 'Not Assigned',
  Started: 'Started',
  Aborted: 'Aborted',
  Completed: 'Completed',
  ManualHandled: 'Manual Handled',
  Canceled: 'Canceled',
  Suggestion: 'Suggestion'
};

const status = {
  InAuction: 'InAuction',
  ManualHandled: 'ManualHandled',
  InMarket: 'InMarket',
  Assigned: 'Assigned',
  Unassigned: 'Unassigned',
  Started: 'Started',
  Aborted: 'Aborted',
  Completed: 'Completed',
  Canceled: 'Canceled'
};

const statuses = [
  status.InAuction,
  status.ManualHandled,
  status.InMarket,
  status.Assigned,
  status.Unassigned,
  status.Started,
  status.Aborted,
  status.Completed,
  status.Canceled
]

const group = {
  Unassigned: 'Unassigned',
  Assigned: 'Assigned',
  Started: 'Started',
  Completed: 'Completed',
  Canceled: 'Canceled',
  Aborted: 'Aborted',
  Late: 'Late',
  Active: 'Active',
  Finished: 'Finished',
  ManualHandled: 'ManualHandled'
};

const servicesViewGroups = [
  'Unassigned',
  'Assigned',
  'Started',
  'Aborted',
  'Canceled',
  'Completed',
  'Risk'
];

const threePlServicesGroupStatuses = [
  'UNASSIGNED',
  'ASSIGNED',
  'STARTED',
  'CANCELED',
  'COMPLETED',
  'RISK'
];

const groupToBackground = {
  Unassigned: 'blue-grey-200',
  Assigned: 'blue-500',
  Started: 'light-blue-800',
  Completed: 'green-300',
  Canceled: 'red-200',
  Aborted: 'red-300',
  Late: 'red-100',
  Active: 'blue-grey-300',
  Finished: 'green-300',
  ManualHandled: 'red-200',
};

const statusToBackground = {
  Unassigned: 'blue-grey-200',
  InMarket: 'blue-grey-400',
  InAuction: 'blue-grey-600',
  Assigned: 'blue-500',
  Started: 'light-blue-800',
  Aborted: 'red-300',
  ManualHandled: 'red-300',
  Completed: 'green-300',
  Canceled: 'red-200',
  Suggestion: 'light-blue-800'
};

const startedStatuses = ['Assigned', 'Started', 'Aborted', 'Completed', 'Canceled'];

const actions = {
  Assign: {
    id: 'assignAgent',
    title: 'Agent Assign',
    icon: 'agent',
    permission: 'services.actions.assign'
  },
  AssignCanceledPickup: {
    id: 'assignCanceledPickup',
    title: 'Assign',
    icon: 'agent',
    permission: 'services.actions.assign'
  },
  ReassignCanceledDropoff: {
    id: 'reassignCanceledDropoff',
    title: 'Revert',
    icon: 'assign-outline',
    permission: 'services.actions.assign'
  },
  AutoAssign: {
    id: 'autoAssignAgent',
    title: 'Auto Assign Agent',
    icon: 'assign-outline',
    permission: 'services.actions.assign'
  },
  AssignRoute: {
    id: 'assignRoute',
    title: 'Add To Route',
    icon: 'route',
    permission: 'routes.list'
  },
  AssignResourceAllocation: {
    id: 'assignResourceAllocation',
    title: 'Add To Resource',
    icon: 'allocation',
    permission: 'fleetManagement.allocations.list'
  },
  Auction: {
    id: 'auction',
    title: 'Auction',
    icon: 'dollar-circle',
    permission: 'market.create'
  },
  EditMetaData: {
    id: 'editMetaData',
    title: 'Edit Meta Data',
    icon: 'default',
    permission: 'services.update'
  },
  Reset: {
    id: 'reset',
    title: 'Reset',
    icon: 'reset',
    permission: 'services.actions.reset'
  },
  Cancel: {
    id: 'cancel',
    title: 'Cancel',
    icon: 'close-circle-outline',
    permission: 'services.actions.delete'
  },
  SendToMarket: {
    id: 'sendToMarket',
    title: 'SendToMarket',
    icon: 'market-outline',
    permission: 'market.create'
  },
  ManualHandle: {
    id: 'manualHandle',
    title: 'ManualHandle',
    icon: 'check-circle-outline',
    permission: 'services.actions.manual'
  },
  Note: {
    id: 'note',
    title: 'AddNote',
    icon: 'note',
    permission: 'services.actions.notes'
  },
  BulkSMS: {
    id: 'bulkSMS',
    title: 'bulkSMS',
    icon: 'message-outline',
    permission: 'sms.send'
  },
  CreateRoute: {
    id: 'createRoute',
    title: 'Create Route',
    icon: 'route',
    permission: 'routes.list'
  },
  Edit: {
    id: 'edit',
    title: 'Edit',
    icon: 'edit-outline',
    permission: 'services.update'
  },
  EditTimeWindow: {
    id: 'editTimeWindow',
    title: 'EditTimeWindow',
    icon: 'time-window-outline',
    permission: 'services.update'
  },
  EditLocation: {
    id: 'editLocation',
    title: 'EditLocation',
    icon: 'edit-outline',
    permission: 'services.update'
  },
  SendToPlanning: {
    id: 'sendToPlanning',
    title: 'Send To Planning',
    icon: 'planning',
    permission: 'planning.servicePlanning.create'
  },
  Duplicate: {
    id: 'duplicate',
    title: 'Duplicate',
    icon: 'duplicate-outline',
    permission: ['orders.create', 'orders.delivery.create']
  },
  Print: {
    id: 'print',
    title: 'Print',
    icon: 'print',
    permission: 'services.list'
  }
};

const serviceActions = {
  Assign: actions.Assign,
  AssignCanceledPickup: actions.AssignCanceledPickup,
  ReassignCanceledDropoff: actions.ReassignCanceledDropoff,
  AutoAssign: actions.AutoAssign,
  AssignRoute: actions.AssignRoute,
  AssignResourceAllocation: actions.AssignResourceAllocation,
  Auction: actions.Auction,
  EditMetaData: actions.EditMetaData,
  Reset: actions.Reset,
  Cancel: actions.Cancel,
  SendToMarket: actions.SendToMarket,
  ManualHandle: actions.ManualHandle,
  CreateRoute: actions.CreateRoute,
  Edit: actions.Edit,
  Duplicate: actions.Duplicate,
  Note: actions.Note,
  BulkSMS: actions.BulkSMS,
  EditLocation: actions.EditLocation,
  SendToPlanning: actions.SendToPlanning
};

const actionsTitle = {
  Assign: 'Assign',
  AutoAssign: 'Auto Assign',
  AssignRoute: 'Assign Route',
  AssignResourceAllocation: 'Assign to Resource',
  Auction: 'Auction',
  Reset: 'Reset',
  Cancel: 'Cancel',
  SendToMarket: 'Send to market',
  ManualHandle: 'Manual Handle',
  CreateRoute: 'Create Route',

};

const extraActions = ['Reset', 'Cancel', 'Edit', 'PrintIkea'];

const serviceActionsByStatusMap = {
  Operation: {
    InAuction: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    InMarket: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    Assigned: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    Unassigned: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    Started: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    Aborted: [
      serviceActions.Reset,
      serviceActions.AssignCanceledPickup,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.EditMetaData
    ],
    Completed: [
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditMetaData
      // serviceActions.Duplicate
    ],
    Canceled: [
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditMetaData
      // serviceActions.Duplicate
    ],
    ManualHandled: [
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
      // serviceActions.Duplicate
    ]
  },
  Delivery: {
    InAuction: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.SendToMarket,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    InMarket: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.SendToMarket,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.Auction,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    Assigned: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    Unassigned: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.SendToMarket,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.Auction,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    Started: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
    ],
    Aborted: [
      serviceActions.AssignCanceledPickup,
      serviceActions.ReassignCanceledDropoff,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.EditMetaData
    ],
    Completed: [
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditMetaData
      // serviceActions.Duplicate
    ],
    Canceled: [
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditMetaData
      // serviceActions.Duplicate
    ],
    ManualHandled: [
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.SendToPlanning,
      serviceActions.EditMetaData
      // serviceActions.Duplicate
    ]
  }
};

const servicesExtraActions = {
  Dispatch_External: {
    id: 'dispatchExternal',
    title: 'Move To External Dispatch',
    icon: 'dispatch',
    permission: ['fulfillment.step.update']
  },
  EditPackages: {
    id: 'editPackages',
    title: 'Edit Packages',
    icon: 'package-outline',
    permission: 'services.update'
  },
  Edit_Delivery: {
    id: 'edit',
    title: 'Edit',
    icon: 'edit-outline',
    permission: ['services.update', 'services.delivery.update']
  },
  Edit_Operation: {
    id: 'edit',
    title: 'Edit',
    icon: 'edit-outline',
    permission: ['services.update', 'services.operation.update']
  },
  Duplicate_Delivery: {
    id: 'Duplicate',
    title: 'Duplicate',
    icon: 'duplicate-outline',
    permission: ['orders.create', 'orders.delivery.create']
  },
  Duplicate_Operation: {
    id: 'Duplicate',
    title: 'Duplicate',
    icon: 'duplicate-outline',
    permission: ['orders.create', 'orders.operation.create']
  },
  Print: {
    id: 'Print',
    title: 'Print',
    icon: 'print',
    permission: 'services.list'
  },
  CreateExpense: {
    id: 'CreateExpense',
    title: 'Create Expense',
    icon: 'dollar',
    permission: 'expenses.create'
  },
  PrintLabel: {
    id: 'PrintLabel',
    title: 'Print Label',
    icon: 'print',
    permission: 'services.list'
  },
  DownloadLabel: {
    id: 'DownloadLabel',
    title: 'Download Label',
    icon: 'download',
    permission: 'services.list'
  },
  PrintIkea: {
    id: 'PrintIkea',
    title: 'Print Ikea',
    icon: 'print',
    permission: 'printers.list'
  }
};

const serviceExtraActionsByStatusMap = {
  Operation: {
    InAuction: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.Dispatch_External
    ],
    InMarket: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.Dispatch_External
    ],
    Assigned: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.CreateExpense,
      servicesExtraActions.Dispatch_External
    ],
    Unassigned: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.Dispatch_External
    ],
    Started: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.CreateExpense,
      servicesExtraActions.Dispatch_External
    ],
    Aborted: [
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel

    ],
    ManualHandled: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense
    ],
    Completed: [
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense
    ],
    Canceled: [
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea

    ]
  },
  Delivery: {
    InAuction: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.Dispatch_External
    ],
    InMarket: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.Dispatch_External

    ],
    Assigned: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense,
      servicesExtraActions.Dispatch_External

    ],
    Unassigned: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.Dispatch_External
    ],
    Started: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense,
      servicesExtraActions.Dispatch_External
    ],
    Aborted: [
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea
    ],
    ManualHandled: [
      servicesExtraActions.EditPackages,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense
    ],
    Completed: [
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense
    ],
    Canceled: [
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.DownloadLabel,
      servicesExtraActions.PrintIkea
    ]
  }
};

const tagsMap = {
  CreateOrderFromApi: 'API',
  CreateOrderFromImport: 'Import',
  CreateOrderFromWeb: 'Web',
  CreateOrderFromConsole: 'Console'
};

const itemToTile = {
  NoPackage: 'Envelop',
  SmallPackage: 'Small Package',
  MediumPackage: 'Medium Package',
  BigPackage: 'Big Package',
  SpecialPackage: 'Special Package',
  Other: 'Other',
  BasePack: 'BasePack',
  Extras: 'Extras',
  CooledPackage: 'Cooled Package',
  FrozenPackage: 'Frozen Package'
};

const podOptionsToTitle = {
  photographIdCard: 'Photo ID',
  photographPerson: '?Photo Person?',
  showIdCard: 'Show ID',
  signature: 'Signature',
  visitSummary: 'visitSummary'
};

const editPriceDisableByStatus = {
  Unassigned: false,
  Assigned: false,
  AssignRoute: false,
  AssignResourceAllocation: false,
  Started: false,
  Completed: true,
  Canceled: true,
  Aborted: false,
  Late: false,
  Active: false,
  Finished: false
};

const podOptionsList = [
  'photographIdCard',
  'photographPerson',
  'showIdCard',
  'signature',
  'visitSummary'
];

const events = {
  newDelivery: {
    quoteLoaded: 'new-delivery-quotes-loaded'
  }
};

const redirectLinkByTextTriggerGroup = {
  Delivery: 'service.delivery.info',
  Operation: 'service.operation.info'
};


const textTriggerGroup = [
  'Delivery',
  'Operation',
  'Order'
];

const redirectStatesByType = {
  Delivery: {
    edit: 'service.edit-delivery',
    duplicate: 'accounts-detail-demand.new-delivery'
  },
  Operation: {
    edit: 'service.edit-operation',
    duplicate: 'accounts-detail-demand.new-operation'
  }
}

const serviceFinishStatuses = ['Completed', 'ManualHandled', 'Canceled', 'Aborted'];

const importDeliveriesSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2FDeliveries_import_pickup_dropoff_example.xls?alt=media&token=6c030d13-0195-40a9-b328-5d4ac6a5a751';
const oldFile = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2FBringoz_deliveries_import_temp.xls?alt=media&token=0104ed6f-c5f3-485a-8328-a69ca11d0ca3';

const importRecurringServicesSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2Frecurring-import_each_day.xlsx?alt=media&token=7c16fa59-6cea-486c-b428-ffffe15cb37f';

const agentActions = [
  'Assigned',
  'Heading',
  'Approaching',
  'Arrived',
  'Departed',
  'ContactNotAvailable',
  'Canceled'
];

const autonomousServiceActions = ['note', 'Duplicate', 'Print', 'PrintLabel', 'PrintIkea'];


angular
  .module('bringoz.admin.deliveries')
  .constant('deliveriesConstants', {
    serviceTypes: serviceTypes,
    servicesAssignRouteTableColumns: servicesAssignRouteTableColumns,
    servicesAssignAgentTableColumns: servicesAssignAgentTableColumns,
    servicesAssignResourceAllocationTableColumns: servicesAssignResourceAllocationTableColumns,
    servicesTableColumnsMap: servicesTableColumnsMap,
    servicesTableColumns: servicesTableColumns,
    threePlServicesTableColumns: threePlServicesTableColumns,
    sendSmsOptions: sendSmsOptions,
    riskTypes: riskTypes,
    statusTitle: statusTitle,
    status: status,
    statuses: statuses,
    group: group,
    groupToBackground: groupToBackground,
    servicesViewGroups: servicesViewGroups,
    statusToBackground: statusToBackground,
    startedStatuses: startedStatuses,
    actions: actions,
    servicesExtraActions: servicesExtraActions,
    actionsTitle: actionsTitle,
    extraActions: extraActions,
    // actionsByStatus :            actionsByStatus,
    // deliveriesActionsByStatusMap:   deliveriesActionsByStatusMap, // OLD
    serviceActionsByStatusMap: serviceActionsByStatusMap,
    serviceExtraActionsByStatusMap: serviceExtraActionsByStatusMap,
    tagsMap: tagsMap,
    itemToTile: itemToTile,
    podOptionsToTitle: podOptionsToTitle,
    editPriceDisableByStatus: editPriceDisableByStatus,
    podOptionsList: podOptionsList,
    events: events,
    importDeliveriesSampleFileLink: importDeliveriesSampleFileLink,
    serviceFinishStatuses: serviceFinishStatuses,
    importRecurringServicesSampleFileLink: importRecurringServicesSampleFileLink,
    redirectLinkByTextTriggerGroup: redirectLinkByTextTriggerGroup,
    textTriggerGroup: textTriggerGroup,
    redirectStatesByType: redirectStatesByType,
    serviceProgressSteps: serviceProgressSteps,
    agentActions: agentActions,
    threePlServicesGroupStatuses: threePlServicesGroupStatuses,
    autonomousServiceActions: autonomousServiceActions
  });
